import { getEnvironment } from "utilities/environment";

export enum EmbedMode {
  NONE = "none",
  EMBED = "embed",
  CHEVRONS = "chevrons",
  STANDALONE_GIG = "standalone-gig",
}

const getEmbedMode = () => {
  const env = getEnvironment();
  const searchParams =
    env === "development" ? "?" + (window.location.hash.split("?")[1] || "") : window.location.search;
  const queryParams = new URLSearchParams(searchParams);
  const mode = queryParams.get("isembedded");

  switch (mode) {
    case "embed":
      return EmbedMode.EMBED;
    case "chevrons":
      return EmbedMode.CHEVRONS;
    case "standalone-gig":
      return EmbedMode.STANDALONE_GIG;
    default:
      return window.top === window.self ? EmbedMode.NONE : EmbedMode.EMBED;
  }
};

export const EMBED_MODE: EmbedMode = getEmbedMode();

export const isEmbeddedMode = (): boolean => EMBED_MODE === EmbedMode.EMBED || EMBED_MODE === EmbedMode.STANDALONE_GIG;

export const isStandaloneGigMode = (): boolean => EMBED_MODE === EmbedMode.STANDALONE_GIG;

export const notifyEmbedHeight = (height: number) => {
  if (window.parent === window) return;
  window.parent.postMessage({ type: "GIG_EMBED_HEIGHT", height }, "*");
};
